import { BasicUser, Id, ResponseDataPaginate, RoleType } from 'src/types'

export enum GroupTreesActionTypes {
  GET_GROUP_TREES = '@groupTrees/GET_GROUP_TREES',
  GET_GROUP_TREES_FAILURE = '@groupTrees/GET_GROUP_TREES_FAILURE',
  GET_GROUP_TREES_SUCCESS = '@groupTrees/GET_GROUP_TREES_SUCCESS',
  SEND_GROUP_TREES = '@groupTrees/SEND_GROUP_TREES',
  SEND_GROUP_TREES_FAILURE = '@groupTrees/SEND_GROUP_TREES_FAILURE',
  SEND_GROUP_TREES_SUCCESS = '@groupTrees/SEND_GROUP_TREES_SUCCESS'
}

export type ResponseDataRequests = ResponseDataPaginate &
  ResponseDataRequestsItem[]

export interface ResponseDataRequestsItem {
  assign_tree_id: Id
  role_type: RoleType
  user_id: Id
  user: BasicUser
}

export type GroupTreesState = {
  readonly error: string
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly sendGroupTreesError: string
  readonly sendGroupTreesLoading: boolean
  readonly total_results: number
}
